import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ControlOptionDto } from '../models/ControlOptionDto';
import { StatusColorDto, StatusColorsDto } from '../models/StatusColorDto';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class StatusColorService extends BaseService {

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  getStatusColor(id: string, statusLevel: string, dbname: string): Observable<StatusColorDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<StatusColorDto>(`${this.statusColor}/${id}&statusLevel=${statusLevel}`, { headers: headers });
  }

  loadStatusColors(searchText: string, valueConfAttrId: string, valueConfPageId: string, page: number, pageSize: number, dbname: string): Observable<StatusColorsDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<StatusColorsDto>(`${this.statusColor}?searchText=${searchText}&valueConfAttrId=${valueConfAttrId}&valueConfPageId=${valueConfPageId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  createStatusColor(statusColorDto: StatusColorDto, dbname: string): Observable<StatusColorDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<StatusColorDto>(`${this.statusColor}`, statusColorDto, { headers: headers });
  }

  createControlOption(controlOptionDto: ControlOptionDto, dbname: string): Observable<ControlOptionDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<ControlOptionDto>(`${this.statusColor}`, controlOptionDto, { headers: headers });
  }

  updateStatusColor(statusColorDto: StatusColorDto, dbname: string): Observable<StatusColorDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<StatusColorDto>(`${this.statusColor}`, statusColorDto, { headers: headers });
  }

  deleteStatusColor(statusColorDto: StatusColorDto, dbname: string): Observable<StatusColorDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<StatusColorDto>(`${this.statusColor}/${statusColorDto.id}&statusLevel=${statusColorDto.statusLevel}`, { headers: headers });
  }
}
